// extracted by mini-css-extract-plugin
export var defaultWrapper = "_kc-3";
export var downloadButton = "_kc-4";
export var fileContainer = "_kc-9 _kc-7";
export var fileContainerBase = "_kc-7";
export var fileContainerBaseSm = "_kc-a _kc-7";
export var fileContainerFixedHeight = "_kc-8 _kc-7";
export var fileContainerFixedHeightSm = "_kc-c _kc-a _kc-7";
export var fileContainerSm = "_kc-b _kc-a _kc-7";
export var fileInfo = "_kc-5";
export var fileInfoWidthRestricted = "_kc-6";
export var fileType = "_kc-1";
export var fileTypeName = "_kc-2";
export var fileTypeSm = "_kc-d _kc-1";
export var image = "_kc-0";
export var link = "_kc-f";
export var overflowEllipsis = "_kc-e";